import React, { FC, useCallback, useState } from 'react'
import { SearchZoneProps } from './SearchZone.props'
import { Icon } from '@wmgtech/legato'

import './SearchZone.scss'

const SearchZone: FC<SearchZoneProps> = ({
  zoneSearchHandler,
  searchBoxIconName = 'file-magnifying-glass',
  inputId = 'search-input',
  placeholder = 'Search'
}) => {
  const [value, setValue] = useState('')

  const setValueHandler = useCallback(
    ({ target: { value } }) => {
      setValue(value)

      return zoneSearchHandler(value)
    },
    [zoneSearchHandler]
  )

  return (
    <div className="search-zone">
      <div className="search-zone-box">
        <label className="search-zone-box__label">
          <input
            id={inputId}
            className="search-zone-box__field"
            onChange={setValueHandler}
            value={value}
            autoComplete="off"
            placeholder={placeholder}
          />
          <Icon className="search-zone-box__icon" name={searchBoxIconName as any} />
        </label>
      </div>
    </div>
  )
}

export default SearchZone
